import React, { useContext, useEffect, useState } from "react";
import { contextApi } from "../context/contextApi";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { ThemeToggle } from "./common/ThemeToggle";
import { api } from "../services/config";

export const Header = () => {
  const context = useContext(contextApi);
  const [show, setShow] = useState(false);
  const [profile, setProfile] = useState(() => {
    const storedProfile = localStorage.getItem("profile");
    return storedProfile ? JSON.parse(storedProfile) : {};
  });
  const navigate = useNavigate();
  const token = localStorage.getItem("login");
  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await api.get("profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const newProfile = response.data.data;
        setProfile(newProfile);
        localStorage.setItem("profile", JSON.stringify(newProfile));
      } catch (error) {
        console.log(error);
      }
    };
    getProfile();
  }, [token]);

  const logOut = async () => {
    const clickData = {
      userId: profile.id,
      clicks: context.clicks,
    };

    console.log(clickData);
    try {
      await axios.post("https://jsonplaceholder.typicode.com/posts", clickData);
      console.log("Click report sent successfully:", clickData);
    } catch (error) {
      console.error("Error sending click report:", error);
    }
    localStorage.removeItem("login");
    localStorage.removeItem("profile");
    localStorage.removeItem("mobile");
    window.location.href = "/login";
  };

  return context.login ? (
    <div className="header py-4 px-6 shadow-lg">
      <div className="flex flex-row justify-between items-center">
        <div
          className="icon-menu cursor-pointer p-2 rounded-lg hover:bg-primary-bg transition-all duration-300 md:hidden"
          onClick={() => context.setMenu(!context.menu)}
        >
          <span className="block w-full h-0.5 bg-primary dark:bg-white mb-1 transition-all duration-300 "></span>
          <span className="block w-4/5 h-0.5 bg-primary dark:bg-white mb-1 transition-all duration-300"></span>
          <span className="block w-3/5 h-0.5 bg-primary dark:bg-white transition-all duration-300"></span>
        </div>
        <div className="hidden md:block"></div>

        <div className="user-profile cursor-pointer relative flex items-center gap-4">
          <ThemeToggle />

          <div
            className="flex items-center gap-2"
            onClick={() => setShow(!show)}
          >
            <img
              src="images/front.png"
              width={32}
              className="rounded-full border-2 border-primary dark:border-primary"
              alt=""
            />
            <img
              src="images/down.png"
              width={16}
              className="transition-transform duration-300 dark:brightness-0 dark:saturate-100 dark:invert dark:hue-rotate-45"
              style={{ transform: show ? "rotate(180deg)" : "rotate(0deg)" }}
              alt=""
            />
          </div>
          <div
            className={`card absolute left-0 top-full p-4 w-64 mt-3 z-50 ${
              show ? "block" : "hidden"
            }`}
          >
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-default">
              <img
                src="/images/user.png"
                alt=""
                className="w-8 h-8 dark:brightness-0 dark:saturate-100 dark:invert dark:hue-rotate-45"
              />
              <div>
                <p className="font-semibold text-primary">
                  {profile.name + " " + profile.lastname}
                </p>
                <p className="text-sm text-muted">مشتری</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between py-2 text-sm">
                <span className="text-muted">شناسه مشتری</span>
                <span className="font-vazir-num text-primary">
                  {profile.code}
                </span>
              </div>
              <div className="flex justify-between py-2 text-sm">
                <span className="text-muted">تلفن همراه</span>
                <span className="font-vazir-num">{profile.mobile}</span>
              </div>
              <div className="border-t border-default pt-3">
                <Link
                  to="/passwordUser"
                  className="flex items-center gap-2 py-2 text-sm text-secondary hover:text-secondary-dark transition-colors duration-300"
                >
                  <span>🔒</span>
                  تغییر پسورد
                </Link>
                <button
                  className="flex items-center gap-2 py-2 text-sm text-error hover:text-error-dark transition-colors duration-300 w-full"
                  onClick={logOut}
                >
                  <span>🚪</span>
                  خروج
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
